module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1534-162223d2343781f6222314394b227518.png";